import {
    PartsProductOptions,
    PartsProductOptionsFeatherKindEnum as FK,
} from '@app/react/const/type';

export const isFeatherNone = (
    parts: { options: PartsProductOptions } | null,
): boolean => (parts?.options?.featherKind === FK.None);
